import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

import { TextField } from 'material-ui';

import '../../../grid.css';

class Contact extends Component {
    static propTypes = {
        isLocked: PropTypes.bool.isRequired,
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        phone: PropTypes.string.isRequired,
        position: PropTypes.string.isRequired,
        email: PropTypes.string.isRequired,
        setNameChange: PropTypes.func.isRequired,
        setPhoneChange: PropTypes.func.isRequired,
        setPositionChange: PropTypes.func.isRequired,
        setEmailChange: PropTypes.func.isRequired,
        setLastNameChange: PropTypes.func.isRequired,
        updateClientStatus: PropTypes.func.isRequired,
    };

    handleNameChange(value) {
        const { setNameChange, updateClientStatus } = this.props;
        setNameChange(value);
        updateClientStatus(null);
    }
    handleLastNameChange(value) {
        const { setLastNameChange, updateClientStatus } = this.props;
        setLastNameChange(value);
        updateClientStatus(null);
    }
    handlePhoneChange(value) {
        const { setPhoneChange, updateClientStatus } = this.props;
        setPhoneChange(value);
        updateClientStatus(null);
    }

    handleEmailChange(value) {
        const { setEmailChange, updateClientStatus } = this.props;
        setEmailChange(value);
        updateClientStatus(null);
    }

    handlePoistionChange(value) {
        const { setPositionChange, updateClientStatus } = this.props;
        setPositionChange(value);
        updateClientStatus(null);
    }

    render() {
        const {
            isLocked, firstName, phone, position, email, lastName,
        } = this.props;
        return (
            <div className="col span-1-of-2">
                <h1>Contact Person</h1>
                <TextField
                    floatingLabelText="First Name"
                    defaultValue={firstName}
                    onChange={(e, value) => this.handleNameChange(value)}
                    type="text"
                    disabled={isLocked}
                    fullWidth
                />
                <TextField
                    floatingLabelText="Last Name"
                    defaultValue={lastName}
                    onChange={(e, value) => this.handleLastNameChange(value)}
                    type="text"
                    disabled={isLocked}
                    fullWidth
                />

                <TextField
                    floatingLabelText="Phone"
                    defaultValue={phone}
                    onChange={(e, value) => this.handlePhoneChange(value)}
                    type="number"
                    disabled={isLocked}
                    fullWidth
                />

                <TextField
                    floatingLabelText="Email"
                    defaultValue={email}
                    onChange={(e, value) => this.handleEmailChange(value)}
                    type="email"
                    disabled={isLocked}
                    fullWidth
                />
                <TextField
                    floatingLabelText="Position"
                    defaultValue={position}
                    onChange={(e, value) => this.handlePoistionChange(value)}
                    type="text"
                    disabled={isLocked}
                    fullWidth
                />
            </div>
        );
    }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/containers/AddClient/Contact/Contact.js